<script>
  import { beforeUpdate, onMount, createEventDispatcher } from "svelte";
  import Details from "../components/useraccount/details.svelte";
  import EditDetails from "../components/useraccount/editdetails.svelte";
  import ChangePassword from "../components/useraccount/changePassword.svelte";
  import { UpdateUserStore, User } from "../store.js";
  import Modal from "../components/HTMLElements/Modal.svelte";
  import wrappedFetch from "../wrappedFetch.js";
  export let step = "details";
  export let showModal = false;
  export let emailChanged = false;
  const dispatch = createEventDispatcher();
  let Route = Details;

  async function getParent() {
    const resp = await wrappedFetch("user/getparent",{method: "post"});
    UpdateUserStore.set(await resp.json());
    
    //if (IS_DEV) console.log("Got address back, the LA name is: ", $UpdateUserStore.address.laName);
   //   if($UpdateUserStore.address && ($UpdateUserStore.address.addr == "" ||!$UpdateUserStore.address.addr )) $UpdateUserStore.address= null;
  }
  getParent();

$: {
    if ($User == null) {
      dispatch("pageChange", "/signin");
    }
    else{
     switch (step) {
       case "details":
         Route = Details;
         break;
       case "editaccount":
         Route = EditDetails;
         break;
       case "changepassword":
         Route = ChangePassword;
         break;
     }
    }
  }

</script>

<svelte:head>
  <title>Edit Account | eAdmissions</title>
</svelte:head>
<section class="section">
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-9-tablet is-8-desktop is-6-widescreen">
        <!-- <main> -->
          {#if $UpdateUserStore != null && $UpdateUserStore.id != null}
            <svelte:component
              this={Route}
              on:pageChange={event => dispatch('pageChange', event.detail)}
               on:notification={event => dispatch('notification', event.detail)}
              bind:emailChanged />
          {/if}
        <!-- </main>         -->
      </div>
    </div>
  </div>

</section>

<!-- <Modal bind:showModal>
  {#if emailChanged}
    <p>
      You have been sent a validation email. You must complete the validation
      process before starting your application.
    </p>
  {/if}
  <p>Your details have been updated successfully!!</p>
</Modal> -->
